import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const UserRegistration = lazy(() => import('../../container/user/userRegistration'));
const UserList = lazy(() => import('../../container/user/userList'));
const UserUpdate = lazy(() => import('../../container/user/userUpdate'));
const UserDetails = lazy(() => import('../../container/user/userDetail/userDetails'));

export default function UserRoute() {
  return (
    <Routes>
      <Route path="registration" element={<UserRegistration />} />
      <Route path="list" element={<UserList />} />
      <Route path="detail/:id" element={<UserDetails />} />
      <Route path="update/:id" element={<UserUpdate />} />
    </Routes>
  );
}
